@if (hasRows || (visibleTreeselectorValues) || (!visaEndastMedProduktionsmal)) {
  <div class="container"
    >
    <div class="table-header col-12">
      <rask-header size="4">
        <span>{{ handelssortimentsgruppInformation.handelssortimentsgruppNamn }}</span>
        @if (visaFordelaVolym) {
          <label class="volym-text">Att fördela: {{ volymAttFordela }}</label>
        }
        @if (isProduktvalApplicable) {
          <rask-action-button icon="far fa-edit" [disabled]="!canEdit"
            (click)="showTree($event)">
            {{texts.redigera}}
          </rask-action-button>
        }
        <rask-tree-selector class="tree-selector" #tree
          [visibilityControlledByCaller]="true"
          aid="produktval-handelssortiment-selector"
          [items]="visibleTreeselectorValues"
          [selectionStrategyType]="selectionStrategyType"
          [emptyText]="texts.emptyTreeSelectorText"
          (onSelectionEvent)="onTreeSelectionEvent($event)"
          [onBeforeSelectionEvent]="onTreeBeforeSelectionEvent"
          [(ngModel)]="result"
          [autoSort]="true"
          [sortExpression]="treeSelectorSortExpression">
        </rask-tree-selector>
      </rask-header>
    </div>
    @if (hasRows) {
      <div>
        @if (isDivLayout) {
          <div>
            @for (produktvalsrad of produktvalsrader; track $index; let i = $index) {
              <div class="content">
                <div>
                  <div class="row header" [ngClass]="{'clickable': isProduktvalApplicable}"
                    (click)="isProduktvalApplicable && produktvalsrad.collapsed = !produktvalsrad.collapsed"
                    [attr.aria-controls]="'collapse_'">
                    <div class="col-1 svea-text">
                      @if (isProduktvalApplicable) {
                        <i class="caret far fa-chevron-down" [ngClass]="{'open': !produktvalsrad.collapsed}"
                        ></i>
                      }
                    </div>
                    <div class="col-7 svea-text" [innerHTML]="produktvalsrad.rowTextAsHTML" nowrap></div>
                    <div class="col-2 svea-text" nowrap>
                      <i aid="pin-check" class="far" [ngClass]="getCheckedClass(produktvalsrad)"></i>
                    </div>
                  </div>
                  <div class="header-right-container col-2">
                    <rask-input-number
                      aid="justera-kvantitet"
                      [(ngModel)]="produktvalsrad.justeradKvantitet"
                      (ngModelChange)="onJusteradKvantitetChange($event, produktvalsrad)"
                      [disabled]="!produktvalsrad.hasProdukt || !canEdit"
                      [min]="0"
                      [placeholder]="produktvalsrad.simuleradKvantitetText">
                    </rask-input-number>
                  </div>
                </div>
                <div class="row collapse" id="collapse_" [ngbCollapse]="produktvalsrad.collapsed">
                  <div class="col-7 offset-1">
                    @if (produktvalsrad.hasPinnar) {
                      <rask-selector
                        [label]="texts.medTillUtbytessimulering"
                        [showHeader]="true"
                        [ngModel]="produktvalsrad.medTillUtbytessimulering"
                        (ngModelChange)="onMedTillUtbytessimuleringChange($event, produktvalsrad)"
                        [values]="produktvalsrad.produktinstruktioner"
                        [viewFormatter]="produktvalsrad.produktinstruktionDisplayValueFormatter"
                        [formatter]="produktvalsrad.produktinstruktionValueFormatter"
                        [disabled]="!canEdit"
                        [infoText]="texts.utbyteInfoText">
                      </rask-selector>
                    }
                    @if (!produktvalsrad.hasPinnar) {
                      <rask-selector
                        [label]="texts.medTillUtbytessimulering"
                        [showHeader]="true"
                        [ngModel]="produktvalsrad.medTillUtbytessimulering"
                        [disabled]="true"
                        [viewFormatter]="produktvalsrad.produktinstruktionDisplayValueFormatter"
                        [infoText]="texts.utbyteInfoText">
                      </rask-selector>
                    }
                  </div>
                  <div class="col-4">
                    <rask-input
                      [label]="isSimuleringApplicable ? texts.simuleradVolym : texts.kontrakteradVolymText"
                      [(ngModel)]="produktvalsrad.simuleradKvantitetText"
                      [readonly]="true">
                    </rask-input>
                  </div>
                </div>
                @if (produktvalsrad.valideringsMeddelande) {
                  <div class="row validation-message">
                    <rask-validation-message-row message="{{produktvalsrad.valideringsMeddelande}}" type="error">
                    </rask-validation-message-row>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <div>
            <table class="svea-table fkm-table mt-2">
              <thead>
                <tr class="rask-header-row rask-row">
                  <th class="fkm-mediumcell">{{texts.tableHeaders.handelssortiment}}</th>
                  <th class="fkm-mediumcell">{{texts.tableHeaders.produkt}}</th>
                  <th class="fkm-mediumcell">{{texts.tableHeaders.pin}}</th>
                  <th class="fkm-mediumcell">{{texts.tableHeaders.medTillUtbytessimulering}}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container>
                  @for (produktvalsrad of produktvalsrader; track produktvalsrad) {
                    <tr
                      class="rask-row fkm-row">
                      <ng-container>
                        <td>
                          <span>{{produktvalsrad.namn}}</span>
                        </td>
                        <td>
                          <span>{{produktvalsrad.produkt}}</span>
                        </td>
                        <td>
                          <span>{{produktvalsrad.pinText}}</span>
                        </td>
                        <td class="svea-input fkm-input-col">
                          @if (produktvalsrad.hasPinnar) {
                            <rask-selector class="cell"
                              [ngModel]="produktvalsrad.medTillUtbytessimulering"
                              (ngModelChange)="onMedTillUtbytessimuleringChange($event, produktvalsrad)"
                              [values]="produktvalsrad.produktinstruktioner"
                              [viewFormatter]="produktvalsrad.produktinstruktionDisplayValueFormatter"
                              [disabled]="!canEdit"
                              [formatter]="produktvalsrad.produktinstruktionValueFormatter">
                            </rask-selector>
                          }
                          @if (!produktvalsrad.hasPinnar) {
                            <rask-selector
                              [ngModel]="produktvalsrad.medTillUtbytessimulering"
                              [disabled]="true"
                              [viewFormatter]="produktvalsrad.produktinstruktionDisplayValueFormatter">
                            </rask-selector>
                          }
                        </td>
                      </ng-container>
                    </tr>
                  }
                </ng-container>
              </tbody>
            </table>
          </div>
        }
      </div>
    }
  </div>
}
